export default __webpack_public_path__ + "assets/arrow-back.fff023a6.svg";